var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClassroomButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 145,
    viewBox: "0 0 178 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.004 76.4277C167.375 79.7723 167.091 83.1725 167.157 86.5749C167.157 96.9251 169.037 96.2401 170.299 98.4133",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177 99.9785L105.87 144L5.94727 125.034",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.231 98.6758L177 99.978",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0956 90.0691L5.20117 95.6501L105.573 114.405L176.694 70.3836L158.067 66.8574",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23545 95.6914C5.23545 95.6914 1 95.6914 1 110.642C1 121 3.47349 124.467 5.48956 124.873",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.108 114.084C102.108 114.084 97.873 112.731 97.873 128.264C97.873 138.615 99.7621 140.348 101.016 142.504L170.774 99.2773",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.365 48.084C156.596 51.4099 156.249 54.8189 156.331 58.2312C156.331 67.2284 157.974 66.6872 159.067 68.5729",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0449 91.4291L103.058 108.256L164.895 69.9847L159.016 68.8516",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143.387 56.8445L164.632 43.6954L131.621 37.9707",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4302 47.0605L15.5703 65.2409L102.795 81.9669L136.594 61.0468",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5449 65.6642C15.5449 65.6642 11.8516 65.4697 11.8516 78.9655C11.8516 87.9711 13.4949 89.0535 14.5876 90.9307",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.115 77.6534L159.474 69.375",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7883 81.6892C99.7883 81.6892 96.1035 81.4947 96.1035 94.9905C96.1035 103.996 97.7384 105.078 98.8311 106.956L141.618 80.666",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6524 97.7791L73.223 91.1665L66.8359 95.6059V82.9727L79.6524 85.1458V97.7791Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6211 80.8594L89.0303 86.5333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3262 124.982L98.39 126.521",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8438 96.6133L95.9076 98.1523",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5742 130.309L97.4919 132.659",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M131.74 36.8789V52.8354C131.74 52.8354 124.421 66.6356 89.3854 66.6356C54.3498 66.6356 45.125 52.8354 45.125 52.8354V36.8789",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5361 28.0676L89.0042 50.2562L162.472 28.0676L162.532 24.0341L89.0042 1L15.57 23.9411L15.5361 28.0676Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M162.532 24.0344L89.0299 45.8424L15.5703 23.9414",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9844 20.2031L139.685 30.5025V55.304",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6172 19.3924C82.6172 20.3394 85.4973 21.0836 89.0551 21.0836C92.6129 21.0836 95.493 20.3141 95.493 19.3924C95.493 18.4707 92.6129 17.7012 89.0551 17.7012C85.4973 17.7012 82.6172 18.4453 82.6172 19.3924Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M145.996 79.8932C145.996 74.0163 146.962 63.0488 140.067 63.0488C133.171 63.0488 134.137 74.0416 134.137 79.8932H145.996Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M143.455 57.9422C143.101 57.1013 142.446 56.4218 141.618 56.0355C140.791 55.6493 139.848 55.5838 138.975 55.8519C138.102 56.1199 137.359 56.7023 136.892 57.4861C136.424 58.2699 136.265 59.1991 136.445 60.0933C136.626 60.9875 137.132 61.783 137.867 62.3254C138.602 62.8677 139.512 63.1182 140.421 63.0282C141.331 62.9383 142.174 62.5142 142.788 61.8385C143.402 61.1627 143.742 60.2834 143.743 59.3712C143.744 58.8804 143.646 58.3942 143.455 57.9422",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0381 45.8418V50.2558",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroomButton);
export default __webpack_public_path__ + "static/media/classroomButton.43efcc66.svg";
export { ForwardRef as ReactComponent };